import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './config/router.config';
import store from './config/store.config';
import MintUI from 'mint-ui';
import VueLazyload from 'vue-lazyload';
import {
  getAuthCodeUrl,
  initUserIdentity,
  getUserIdentity,
  getCouponActivity
} from 'components/api/interface-hhy';
import {
  getClientType
} from 'components/api/utils';
import {
  BUSINESS_TYPE_TS,
  BUSINESS_TYPE_STATUS_OPEN,
  getBranchBusinessInfo,
  getTableInfo,
  getBusinessSetting
} from 'components/api/interface-saas';
import {
  APP_ENV,
  setLocalUserIdentity
} from './config/params-local';
import MetaInfo from 'vue-meta-info';  // 用于处理页面title和关键词等
import {
  updateUserIdentity,
  getUserByThirdChannelInfo,
  getUserInfoByUserId,
  CLIENT_ALIPAY, CLIENT_WECHAT
} from './components/api/interface-hhy'
import {ROUTES_WITHOUT_IDENTITY} from './config/params';
import 'src/filter/index';
import {TS_PAY_TYPE_BEFORE} from './components/api/interface-saas';
import {getBranchInfoByAliShopId} from './components/api/interface-merchant-center';
import {getUserPreOrderSummary} from './components/api/interface-saas-order';
import {wxCloseWindow, wxDisableShareMenu} from 'src/components/api/weixin-jsapi';

Vue.use(MintUI);
Vue.use(MetaInfo);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/static/img/default.png',
  loading: '/static/img/loading33.gif',
  attempt: 1
});

// 全局导航钩子
router.beforeEach((to, from, next) => {
  let clientType = getClientType();
  if (clientType === '') {
    next({name: 'error', params: {message: '请在微信或支付宝内打开页面'}});
    return;
  }
  let userIdentity = getUserIdentity();
  // 返回到根路径时关闭网页窗口
  if (userIdentity && to.path === '/') {
    if (clientType === CLIENT_WECHAT) {
      wxCloseWindow();
    }
    return;
  }
  // 二合一码关注消息判断链接是否过期
  let expireSeconds = to.query.expire,
    nowMilliseconds = (new Date()).getTime();
  if (expireSeconds && nowMilliseconds > expireSeconds * 1000) {
    next({name: 'error2', params: {title: '页面已过期', label: '请重新扫码打开'}});
    return;
  }
  if (to.name === 'feedback' && !to.query.shop_id) {
    next({name: 'error', params: {message: '门店信息缺失'}});
    return;
  }
  if (ROUTES_WITHOUT_IDENTITY.includes(to.name)) {
    next();
    return;
  }
  let toQuery = to.query;
  // 测试
  if (APP_ENV !== 'server' && !userIdentity) {
    setLocalUserIdentity(to.query.businessType);
    // 显示欢迎页
    store.commit('setWelcomeImgVisible', true);
    _beforeEach(to, next, true);
    return;
  }
  // 入口1：扫描口碑门店码 /?merchant_pid=&shop_id= : 调起支付宝扫一扫
  // 入口2：扫码点餐(扫口碑码) /?merchant_pid=&shop_id=&user_id=&table_num=
  // 入口3：扫码点餐(扫好客云桌台码)  /?#/goods?org_id=&shop_id=&table_num=
  // 入口4：外卖/预约自取/预约堂食/订单中心 /?#/stores(或member)?authId=&businessType=
  // 入口5：取得授权code后跳转回来
  // 入口6：支付宝调起订单详情页(目前扫码点餐订单详情页无业务交互操作, 可直接显示) /?#/orderDetail/orderId/branchId
  // 入口7：支付宝码码上付右下角[买单] /?biz_type=online_pay&table_num=&merchant_pid=&shop_id=&user_id=
  // 入口8：支付宝码码上付card位[买单] /?biz_type=online_pay&table_num=&merchant_pid=&shop_id
  // 入口9：支付宝码码上付card位[订单详情] /#/aliScanOrderDetail?outTradeNo=
  // 入口10: 微信预点餐：/?#/stores?authId=179
  // 入口11： 支付宝预点餐（扫口碑门店码）/?merchant_pid=&shop_id=&user_id=&table_num=空

  // 入口6
  if (to.name === 'orderDetail' && (!to.params.branchId || !to.params.orderId)) {
    next({name: 'error', params: {message: '页面参数错误'}});
    return;
  }
  // '?#'丢失'?'
  let checkUrl = _checkUrl();
  if (checkUrl !== '') {
    window.location.href = checkUrl;
    next(false);
    return;
  }
  // 已登录
  if (userIdentity) {
    _beforeEach(to, next);
    return;
  }
  // http://d.hocyun.cn/custom/?merchant_pid=&shop_id=&user_id=&table_num=&...
  // 口碑门店插件访问时丢失(?#), 造成to.query参数无法获取
  if (Object.keys(toQuery).length === 0 && Object.keys(to.params).length === 0) {
    let path = _getAliServiceRouterPath(to.path);
    window.location.href = window.location.protocol +
      '//' + window.location.host +
      window.location.pathname +
      '?#' + path +
      window.location.search;
    next(false);
    return;
  }
  let businessType;
  let menuType;
  if (toQuery.menuType) {
    menuType = toQuery.menuType;
  }
  if (toQuery.businessType) {
    businessType = toQuery.businessType;
  } else if (to.name === 'orderDetail') {
    businessType = 'MEMBER';
  } else {
    businessType = BUSINESS_TYPE_TS;
  }
  let tableNum = toQuery.table_num || '',
    tableId = toQuery.table_id || 0,
    authCode = toQuery.code,
    isFromAliTs = clientType === CLIENT_ALIPAY && businessType === BUSINESS_TYPE_TS && toQuery.merchant_pid && toQuery.shop_id,   // 支付宝接入的扫码点餐
    isFromAliWithUserId = isFromAliTs && toQuery.user_id,  // 支付宝口碑码扫码接入扫码点餐，并提供了正确的支付宝用户id
    isFromAliWithoutUserId = isFromAliTs && !toQuery.user_id;  // 支付宝口碑码扫码接入扫码点餐，未提供支付宝用户id
  if (authCode) {   // 入口5: 取得授权code后跳转回来
    let branchId = to.name === 'orderDetail' ? to.params.branchId : (toQuery.shop_id ? toQuery.shop_id : 0),
      authParams = {
        code: authCode,
        state: toQuery.state,
        appid: toQuery.appid ? toQuery.appid : ''
      }, params = {
        branchId: branchId,
        tableId: tableId,
        tableNo: tableNum,
        businessType: businessType,
        clientType: clientType,
        authId: toQuery.authId ? toQuery.authId : '',
        isJC: toQuery.isJC ? toQuery.isJC : 'NO',
        menuType: menuType
      };
    initUserIdentity(params, authParams).then(res => {
      // 显示欢迎页
      store.commit('setWelcomeImgVisible', true);
      // 业务前置判断
      _beforeEach(to, next, true);
    }).catch(err => {
      next({name: 'error', params: {message: err.message || '获取会员失败'}});
    });
  } else if (isFromAliWithUserId) {   // 入口2: 扫码口碑码
    let params = {
      thirdChannel: clientType,
      userThirdValue: toQuery.user_id,
      merchant: toQuery.merchant_pid,
      shop: toQuery.shop_id,
      businessType: businessType,
      tableNo: tableNum
    };
    getUserByThirdChannelInfo(params).then(res => {
      if (toQuery.biz_type === 'online_pay') {  // 支付宝买单
        let nextConfig = {name: 'aliScanPay'};
        next(nextConfig);
        return;
      }
      if (!res.id) {   // 新会员需要授权获取信息的情况
        let path = _getAliServiceRouterPath(to.path);
        let backUrl = window.location.protocol + '//' + window.location.host + window.location.pathname +
            '?#' + path +
            '?org_id=' + res.orgId +
            '&shop_id=' + res.branchId +
            '&table_num=' + tableNum,
          params = {
            branchId: res.branchId,
            businessType: businessType,
            clientType: clientType,
            authId: res.authId
          };
        let authUrl = getAuthCodeUrl(params, backUrl);
        window.location.href = authUrl;
        next(false);
      } else {
        // 业务前置判断
        _beforeEach(to, next, true);
      }
    }).catch(err => {
      next({name: 'error', params: {message: err.message || '获取会员失败'}});
    });
  } else if (isFromAliWithoutUserId) {  // 入口8
    getBranchInfoByAliShopId(toQuery.shop_id).then(data => {
      let branchId = data.branchId,
        backUrl = window.location.protocol + '//' + window.location.host + window.location.pathname +
          '?#' + _getAliServiceRouterPath(to.path) +
          '?shop_id=' + branchId +
          '&table_num=' + tableNum +
          '&biz_type=alipay',
        params = {
          branchId: branchId,
          businessType: businessType,
          clientType: clientType,
          authId: 0
        };
      let authUrl = getAuthCodeUrl(params, backUrl);
      window.location.href = authUrl;
      next(false);
    }).catch(err => {
      console.log(err);
      next({name: 'error', params: {message: '未查询到对应门店'}});
    });
  } else {  // 入口3/4/6: 直接走授权
    let branchId = to.name === 'orderDetail' ? to.params.branchId : (toQuery.shop_id ? toQuery.shop_id : 0),
      urlSep = window.location.hash.indexOf('?') === -1 ? '?' : '&',
      backUrl = to.name !== 'orderDetail' ? window.location.href : window.location.href + urlSep + 'shop_id=' + branchId;
    let params = {
      branchId: branchId,
      businessType: businessType,
      clientType: clientType,
      authId: toQuery.authId ? toQuery.authId : 0
    };
    let authUrl = getAuthCodeUrl(params, backUrl);
    window.location.href = authUrl;
    next(false);
  }
});

// 微信端全页面禁用右上角分享菜单
router.afterEach(() => {
  if (getClientType() === CLIENT_WECHAT) {
    wxDisableShareMenu();
  }
});

/**
 * 业务前置判断
 * @param {Object} to
 * @param {Function} next
 * @param {Boolean} login 是否是新登录操作，用于判断首页是goods还是home
 * @private
 */
async function _beforeEach(to, next, login = false) {
  let userIdentity = getUserIdentity();
  if (to.name === 'alipayWithOutOrder') {   // 码上付-买单
    next();
    return;
  }
  let businessType = to.query.businessType ? to.query.businessType : userIdentity.businessType;
  if (to.query.userId) {  // 好会员回跳，会员信息发生变更
    getUserInfoByUserId(to.query.userId).then(data => {
      let {id, showname, mobile, levelType} = data;
      updateUserIdentity('', {
        userId: id,
        showname,
        mobile,
        levelType
      });
    }).catch(() => {
      next({name: 'error', params: {message: '查询会员信息失败'}});
    });
  }
  if (to.name === 'feedback') {
    next();
    return;
  }
  // 登录操作、单门店业务验证业务是否开通、查询业务设置参数
  let branchId = to.params.branchId || userIdentity.branchId;
  if (login === true && branchId && businessType !== 'MEMBER') {
    if (to.name !== 'aliScanPay') {
      // 判断业务是否开通
      let businessInfo = await getBranchBusinessInfo(branchId).catch(() => {
      });
      if (!businessInfo) {
        next({name: 'error', params: {message: '暂未启用此功能,可联系店内工作人员'}});
        return;
      }
      let index = businessInfo.findIndex(item => {
        return item.businessType === businessType && item.status === BUSINESS_TYPE_STATUS_OPEN;
      });
      if (index === -1) {
        next({name: 'error', params: {message: '暂未启用此功能,可联系店内工作人员'}});
        return;
      }
    }
    // 查询业务设置
    let setting = await getBusinessSetting().catch(() => {
    });
    if (!setting) {
      next({name: 'error', params: {message: '业务设置参数查询错误'}});
      return;
    }
    store.commit('setBusinessSetting', setting);
  }
  // 查询是否有领券下单活动
  let takeCardsRoutes = ['goods', 'aliScanPay', 'home', 'distribution'];
  takeCardsRoutes = []; // 没有使用的
  if (!takeCardsRoutes.includes(to.name) || store.state.takeCardsSearch) {
    store.commit('setTakeCardsModalVisible', false);
  } else if (branchId && !store.state.takeCardsBranchIds.includes(branchId)) {
    getCouponActivity().then(res => {
      if (res && res.length > 0) {
        store.commit('setTakeCardsArr', res);
        store.commit('setTakeCardsModalVisible', true);
      }
    }).catch(err => {
      console.error(err);
    });
    store.commit('setTakeCardsSearch', true);
  }
  switch (businessType) {
    case BUSINESS_TYPE_TS:
      let haveTable = userIdentity.tableNo || userIdentity.tableId;
      // 查询桌台信息
      if (haveTable && ('tableName' in userIdentity) === false) {
        let tableInfo = await getTableInfo().catch(() => {
        });
        if (!tableInfo) {
          next({name: 'error', params: {message: '当前桌台不可用'}});
          return;
        }
        let {id: tableId = 0, tableName = '', tableNo = '', deleted = 'YES', disabled = 'YES'} = tableInfo;
        if (deleted === 'YES' || disabled === 'YES') {
          next({name: 'error', params: {message: '当前桌台不可用'}});
          return;
        }
        updateUserIdentity('', {tableId, tableNo, tableName});
      }
      // 登录操作
      if (login === true) {
        if (to.name !== 'aliScanPay') {
          // 预点餐跳转门店列表页
          if (!haveTable && !branchId) {
            next({name: 'stores'});
            return;
          }
        }
        // 微信后支付或者预点餐下单跳转首页
        let clientType = getClientType(),
          isFromAliApp = clientType === CLIENT_ALIPAY && ((to.query.merchant_pid && to.query.shop_id) || to.query.biz_type === 'alipay');
        isFromAliApp && (updateUserIdentity('entry', 'aliShopPage'));   // 入口为支付宝门店页
        if (!isFromAliApp && (to.name === 'goods' || to.path === '/')) {
          let preOrder = await getUserPreOrderSummary().catch(err => {
            console.error(err)
          });
          if (store.state.businessSetting.checkMode !== TS_PAY_TYPE_BEFORE || (preOrder && preOrder.orderId)) {
            next({name: 'home'});
            return;
          }
        }
        if (to.path === '/') {
          next({name: 'goods'});
        }
      }
      next();
      break;
    default:
      next();
  }
}

/**
 * 口碑服务地址path处理
 * @param defaultPath 默认地址path
 * @private
 */
function _getAliServiceRouterPath(defaultPath) {
  let search = window.location.search;
  if (search.indexOf('biz_type=online_pay') !== -1) {   // 买单
    return '/aliScanPay'
  }
  return defaultPath;
}

/**
 * 检查当前url中是否有?#（防止nginx重定向后?#变成#）
 * @return {*}
 * @private
 */
function _checkUrl() {
  let currentHref = window.location.href;
  if (currentHref.indexOf('#') !== -1 && currentHref.indexOf('?#') === -1) {
    return currentHref.replace('#', '?#');
  }
  return '';
}


new Vue({
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  data: {
    eventHub: new Vue()
  }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js